import angular from 'angular';
import _ from 'lodash';
import Logger from '../../../../../shared/logger';

export const ActiveUsersService = (StatsService) => {
    const getActiveUsersData = function (callback) {
        StatsService.getActiveUsers()
            .then((response) => {
                const activeUsers = response.result;
                StatsService.getOnlineUsers()
                    .then((response) => {
                        const onlineUsers = {
                            recruiters: 0,
                            employers: 0,
                        };
                        if (response.result.length < 2) {
                            return callback({
                                active: activeUsers,
                                online: {
                                    recruiters: 0,
                                    employers: 0,
                                },
                            });
                        }
                        let idx = _.findIndex(response.result, { userType: 'recruiters' });
                        if (idx >= 0) {
                            onlineUsers.recruiters = response.result[idx].count;
                        }
                        idx = -1;
                        idx = _.findIndex(response.result, { userType: 'employers' });
                        if (idx >= 0) {
                            onlineUsers.employers = response.result[idx].count;
                        }
                        callback({

                            active: activeUsers,
                            online: onlineUsers,
                        });
                    })
                    .catch(error => Logger.error(error));
            });
    };

    return {
        getActiveUsersData,
    };
};

angular
    .module('TALENYA-FE')
    .factory('ActiveUsersService', ActiveUsersService);

